import { createContext, ReactNode, useCallback, useContext, useState } from 'react';

export type ResizeAction = 'expand' | 'collapse';

export type PanelId = string;

type FancyPanelResizeCtxType = {
  getAction: (id: PanelId) => ResizeAction | undefined;
  scheduleAction: (id: PanelId, action: ResizeAction) => void;
  removeAction: (id: PanelId) => void;
};

const FancyPanelResizeCtx =
  createContext<FancyPanelResizeCtxType>({
    getAction: () => {},
    scheduleAction: () => {},
    removeAction: () => {},
  });

export type Props = {
  children: ReactNode;
};

export function FancyPanelResizeProvider({ children }: Props) {

  const [actions, setActions] = useState<Record<PanelId, ResizeAction>>({});

  const getAction = (id: PanelId) => actions[id];

  const scheduleAction = useCallback((id: PanelId, action: ResizeAction) => {
    setActions(prevActions => ({ ...prevActions, [id]: action }));
  }, [setActions]);

  const removeAction = useCallback((id: PanelId) => {
    setActions(prevActions => {
      delete prevActions[id];
      return { ...prevActions };
    });
  }, [setActions]);

  return (
    <FancyPanelResizeCtx.Provider value={{ getAction, scheduleAction, removeAction }}>
      {children}
    </FancyPanelResizeCtx.Provider>
  );
}

export function useFancyPanelResize() {
  return useContext(FancyPanelResizeCtx);
}
